<template>
  <div class="form-panel">
    <div class="form-panel__header">
      <h2 class="titulo-h2">Completa tu información básica</h2>
    </div>
    <div class="form-panel__body">
      <transition name="slide" mode="out-in">
        <!-- Selección Nombres -->
        <div v-if="vista == 1" key="nombre" class="form-fields">
          <div class="form-fields__principal">
            <h2 class="titulo-h3-light">Ingresa tus Datos</h2>
            <form class="form" action="">
              <div
                class="form__group"
                :class="{
                  'form__group-invalid': $v.form.nombreCompleto.$error,
                  'form__group-valid': !$v.form.nombreCompleto.$invalid,
                }"
              >
                <i class="icon-field icon-field-arrow"></i>
                <label for="nombreCompleto">Nombre completo</label>
                <input
                  id="nombreCompleto"
                  type="text"
                  autofocus
                  @blur="$v.form.nombreCompleto.$touch()"
                  v-model="form.nombreCompleto"
                  :disabled="disabled"
                />
                <div
                  class="form__group-validation"
                  v-if="$v.form.nombreCompleto.$dirty"
                >
                  <p v-if="!$v.form.nombreCompleto.required">
                    Debes especificar tu nombre.
                  </p>
                  <p v-if="!$v.form.nombreCompleto.minLength">
                    Ingresa al menos 3 letras.
                  </p>
                  <p v-if="!$v.form.nombreCompleto.letrasEspacios">
                    Ingresa solo letras.
                  </p>
                  <p v-if="!$v.form.nombreCompleto.CantidadCadenaNombre">
                    Ingrese un nombre y apellido correcto
                  </p>
                </div>
              </div>
              <!-- <div class="form__group" :class="{'form__group-invalid': $v.form.nombre2.$error, 'form__group-valid': !$v.form.nombre2.$invalid && $v.form.nombre2.$dirty}" style="display:none">
                <i class="icon-field icon-field-arrow"></i>        
                <label for="nombre2">Segundo Nombre</label>
                <input id="nombre2" type="text" @blur="$v.form.nombre2.$touch()" v-model="form.nombre2">
                <div class="form__group-validation" v-if="$v.form.nombre2.$dirty">
                  <p v-if="!$v.form.nombre2.minLength">Ingresa al menos 3 letras.</p>
                  <p v-if="!$v.form.nombre2.letrasEspacios">Ingresa solo letras.</p>
                </div>
              </div>  
               <div class="form__group" :class="{'form__group-invalid': $v.form.apellido1.$error, 'form__group-valid': !$v.form.apellido1.$invalid}" style="display:none">
                <i class="icon-field icon-field-arrow"></i>        
                <label for="nombre1">Primer Apellido</label>
                <input id="nombre1" type="text" @blur="$v.form.apellido1.$touch()" v-model="form.apellido1">
                <div class="form__group-validation" v-if="$v.form.apellido1.$dirty">
                  <p v-if="!$v.form.apellido1.required">Debes especificar tu apellido.</p>
                  <p v-if="!$v.form.apellido1.minLength">Ingresa al menos 3 letras.</p>
                  <p v-if="!$v.form.apellido1.letrasEspacios">Ingresa solo letras.</p>
                </div>
              </div>    
               <div class="form__group" :class="{'form__group-invalid': $v.form.apellido2.$error, 'form__group-valid': !$v.form.apellido2.$invalid && $v.form.apellido2.$dirty}" style="display:none">
                <i class="icon-field icon-field-arrow"></i>        
                <label for="nombre2">Segundo Apellido</label>
                <input id="nombre2" type="text" @blur="$v.form.apellido2.$touch()" v-model="form.apellido2">
                <div class="form__group-validation" v-if="$v.form.apellido2.$dirty">
                  <p v-if="!$v.form.apellido2.minLength">Ingresa al menos 3 letras.</p>
                  <p v-if="!$v.form.apellido2.letrasEspacios">Ingresa solo letras.</p>
                </div>
              </div>    -->
              <div
                class="form__group"
                :class="{
                  'form__group-invalid': $v.form.idTipoDocumento.$error,
                  'form__group-valid': !$v.form.idTipoDocumento.$invalid,
                }"
              >
                <i class="icon-field icon-field-arrow"></i>
                <label for="departamento">Tipo de Documento</label>
                <v-select
                  class="selectField"
                  :items="tiposDocumento"
                  v-model="form.idTipoDocumento"
                  item-text="descripcion"
                  item-value="idTipoDocumento"
                  label="Select"
                  solo
                  :disabled="disabledDocumento"
                ></v-select>
                <div
                  class="form__group-validation"
                  v-if="$v.form.idTipoDocumento.$dirty"
                >
                  <p v-if="!$v.form.idTipoDocumento.minValue">
                    Selecciona un tipo de documento.
                  </p>
                </div>
              </div>
              <div
                class="form__group"
                :class="{
                  'form__group-invalid': $v.form.documento.$error,
                  'form__group-valid': !$v.form.documento.$invalid,
                }"
              >
                <i class="icon-field icon-field-id"></i>
                <label for="nombre1">Documento</label>
                <input
                  id="nombre1"
                  type="text"
                  autofocus
                  @blur="$v.form.documento.$touch()"
                  v-model="form.documento"
                  :disabled="disabledDocumento"
                />
                <div
                  class="form__group-validation"
                  v-if="$v.form.documento.$dirty"
                >
                  <p v-if="!$v.form.documento.required">
                    Ingresa el número de tu documento.
                  </p>
                  <p v-if="!$v.form.documento.minLength">
                    Ingresa al menos 6 dígitos.
                  </p>
                </div>
              </div>
              <div
                class="form__group"
                :class="{
                  'form__group-invalid': $v.form.sexo.$error,
                  'form__group-valid':
                    !$v.form.sexo.$invalid && $v.form.sexo.$dirty,
                }"
              >
                <i class="icon-field icon-field-arrow"></i>
                <label for="nombre2">Sexo</label>
                <v-radio-group
                  v-model="form.sexo"
                  row
                  dark
                  class="grid-area-textbox"
                  :disabled="disabled"
                >
                  <v-radio color="white" label="Mujer" value="F"></v-radio>
                  <v-radio color="white" label="Hombre" value="M"></v-radio>
                </v-radio-group>
              </div>
              <div
                class="form__group"
                :class="{
                  'form__group-invalid': $v.form.telefonoMovil.$error,
                  'form__group-valid': !$v.form.telefonoMovil.$invalid,
                }"
              >
                <i class="icon-field icon-field-cellphone"></i>
                <label for="telefonoMovil">Teléfono Móvil</label>
                <input
                  id="telefonoMovil"
                  type="email"
                  @blur="$v.form.telefonoMovil.$touch()"
                  v-model="form.telefonoMovil"
                />
                <div
                  class="form__group-validation"
                  v-if="$v.form.telefonoMovil.$dirty"
                >
                  <p v-if="!$v.form.telefonoMovil.required">
                    Indica el número de tu celular.
                  </p>
                  <p v-if="!$v.form.telefonoMovil.numeric">
                    Ingresa solo números.
                  </p>
                  <p v-if="!$v.form.telefonoMovil.minLength">
                    El teléfono debe ser de 10 dígitos.
                  </p>
                  <p v-if="!$v.form.telefonoMovil.maxLength">
                    El teléfono debe ser de 10 dígitos.
                  </p>
                </div>
              </div>
              <div
                class="form__group"
                :class="{
                  'form__group-invalid': $v.form.fecha.$error,
                  'form__group-valid': !$v.form.fecha.$invalid,
                }"
              >
                <i class="icon-field icon-field-arrow"></i>
                <label for="fecha">Fecha de Nacimiento</label>
                <input
                  type="text"
                  v-model="form.fecha"
                  label="Seleccione su fecha de nacimiento"
                  hint="YYYY/MM/DD"
                  @click="dialogoFecha = true"
                  :disabled="disabled"
                />
                <div class="form__group-validation" v-if="$v.form.fecha.$dirty">
                  <p v-if="!$v.form.fecha.required">
                    Indica una fecha de nacimiento.
                  </p>
                </div>
                <v-dialog persistent v-model="dialogoFecha" width="330px">
                  <v-card>
                    <v-card-text>
                      <v-date-picker
                        ref="picker"
                        class="grid-center font-family-roboto"
                        locale="es-co"
                        color="pink"
                        header-color="light-blue"
                        year-icon="event"
                        :min="min"
                        :max="max"
                        v-model="form.fecha"
                        :landscape="landscape"
                        :reactive="reactive"
                      ></v-date-picker>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <a
                        @click="cancelarFecha"
                        class="waves-effect waves-light m-btn form-fields__navegacion-izq m-btn-secundario"
                        style="left: -42%; width: 28%"
                        >Cerrar</a
                      >
                      <a
                        @click="asignarfecha"
                        class="waves-effect waves-light m-btn form-fields__navegacion-der"
                        style="left: -4%"
                        >Aceptar</a
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </form>
          </div>
          <div class="form-fields__navegacion">
            <a
              class="waves-effect waves-light m-btn form-fields__navegacion-der"
              tabindex="0"
              @click="adelante()"
              >Continuar</a
            >
          </div>
        </div>

        <!-- Resumen -->
        <div v-if="vista == 2" key="resumen" class="form-fields">
          <div class="form-fields__secundario">
            <h3 class="titulo-h3">Revisa la información</h3>
            <h4 class="titulo-h4">Nombre Completo: {{ nombreCompleto }}</h4>
            <h4 class="titulo-h4">
              Documento: {{ abreviaturaTipoDocumento }} {{ form.documento }}
            </h4>
            <h4 class="titulo-h4">Sexo: {{ descripcionSexo }}</h4>
            <h4 class="titulo-h4">Teléfono Móvil: {{ form.telefonoMovil }}</h4>
            <h4 class="titulo-h4">
              Fecha de Nacimiento (AAAA/MM/DD): {{ form.fecha }}
            </h4>
          </div>
          <div class="form-fields__navegacion">
            <a
              class="waves-effect waves-light m-btn form-fields__navegacion-izq m-btn-secundario"
              tabindex="0"
              @mousedown.prevent="atras()"
              >Anterior</a
            >
            <a
              class="waves-effect waves-light m-btn form-fields__navegacion-der"
              tabindex="0"
              @click="registrar()"
              v-show="visibleRegistrar"
              >Registrarse</a
            >

            <a
              class="waves-effect waves-light m-btn form-fields__navegacion-der"
              tabindex="0"
              @click="actualizar()"
              v-show="visibleActualizar"
              >Actualizar</a
            >
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  /* alpha,*/ numeric,
  minValue,
} from "vuelidate/lib/validators";

const letrasEspacios = (value) => {
  if (typeof value === "undefined" || value === null || value === "") {
    return true;
  }
  return /^(?! )(?!.*  )[a-zA-ZáéíóúÁÉÍÓÚüÜ ]+$/.test(value);
};

const CantidadCadenaNombre = (value) => {
  if (typeof value === "undefined" || value === null || value === "") {
    return true;
  }
  var Cantidad = value.split(" ");
  //alert(Cantidad)
  if (Cantidad.length < 2) {
    return false;
  } else if (Cantidad[1].length == 0) {
    return false;
  }
  return true;
};

export default {
  data() {
    return {
      // fecha vairables inicio
      fechaInicial: null,
      guardar: false,
      landscape: false,
      reactive: true,
      // fecha variables fin
      disabled: false,
      disabledDocumento: false,
      vista: 1,
      resumen: false,
      dialogoFecha: false,
      visibleRegistrar: false,
      visibleActualizar: false,
      form: {
        nombre1: "",
        nombre2: "",
        apellido1: "",
        apellido2: "",
        idTipoDocumento: 0,
        documento: "",
        sexo: "",
        telefonoMovil: "",
        nombreCompleto: "",
        fecha: null,
      },
      tiposDocumento: [
        { idTipoDocumento: 1, descripcion: "C.C." },
        { idTipoDocumento: 3, descripcion: "C.E." },
        { idTipoDocumento: 4, descripcion: "Pasaporte." },
      ],
    };
  },
  // Personalización de fecha inicio
  watch: {
    fecha(newVal, oldVal) {
      if (
        !this.fechaInicial &&
        newVal &&
        this.$refs.picker.activePicker == "DATE" &&
        oldVal != newVal
      ) {
        this.guardar = true;
      } else if (
        this.fechaInicial &&
        newVal != this.fechaInicial &&
        newVal != oldVal
      ) {
        this.guardar = true;
      } else {
        this.guardar = false;
      }
    },
  },
  // Personalizacion de fecha fin
  computed: {
    // Fecha nacimiento config inicio
    min() {
      let fechaActual = new Date();
      return new Date(fechaActual.setFullYear(fechaActual.getFullYear() - 100))
        .toISOString()
        .substr(0, 10);
    },
    max() {
      let fechaActual = new Date();
      return new Date(fechaActual.setFullYear(fechaActual.getFullYear() - 18))
        .toISOString()
        .substr(0, 10);
    },
    // Fecha nacimiento config fin
    descripcionSexo() {
      switch (this.form.sexo) {
        case "F":
          return "Femenino";
        //break;
        case "M":
          return "Masculino";
        //break;
        default:
          return "Femenino";
      }
    },
    abreviaturaTipoDocumento() {
      switch (this.form.idTipoDocumento) {
        case 1:
          return "C.C.";
        //break;
        case 2:
          return "T.I.";
        //break;
        case 3:
          return "C.E.";
        //break;
        case 4:
          return "Pasaporte";
        //break;
        default:
          return "C.C.";
      }
    },
    descripcionTipoDocumento() {
      switch (this.form.idTipoDocumento) {
        case 1:
          return "cédula de ciudadanía";
        //break;
        case 2:
          return "tarjeta de identidad";
        //break;
        case 3:
          return "cédula de extranjería";
        //break;
        case 4:
          return "pasaporte";
        //break;
        default:
          return "cédula de ciudadanía";
      }
    },
    nombreCompleto() {
      return this.form.nombreCompleto;
    },
  },
  methods: {
    cancelarFecha() {
      this.dialogoFecha = false;
    },
    asignarfecha() {
      this.dialogoFecha = false;
    },
    adelante() {
      if (this.$v.form.$invalid) {
        this.$v.form.$touch();
      } else {
        this.vista++;
      }
    },
    atras() {
      this.vista--;
    },
    registrar() {
      //let parametros = this.fecha.split('-')
      //let year = Number(parametros[0])
      //let month = Number(parametros[1])
      //let day = Number(parametros[2])

      let cliente = {
        sexo: this.form.sexo,
        nombre1: this.form.nombre1,
        nombre2: this.form.nombre2,
        apellido1: this.form.apellido1,
        apellido2: this.form.apellido2,
        idTipoDocumento: this.form.idTipoDocumento,
        documento: this.form.documento,
        telefonoMovil: this.form.telefonoMovil,
        nombreCompleto: this.form.nombreCompleto,
        fechaNacimiento: this.form.fecha,
      };
      this.$store.dispatch("guardarCliente", cliente);
    },
    actualizar() {
      let clienteBuscar = this.$store.getters.cliente;
      let idClienteActualizar = clienteBuscar.idCliente;
      let clienteActualizar = {
        sexo: this.form.sexo,
        nombre1: this.form.nombre1,
        nombre2: this.form.nombre2,
        apellido1: this.form.apellido1,
        apellido2: this.form.apellido2,
        idTipoDocumento: this.form.idTipoDocumento,
        documento: this.form.documento,
        telefonoMovil: this.form.telefonoMovil,
        nombreCompleto: this.form.nombreCompleto,
        fechaNacimiento: this.fecha,
        idCliente: idClienteActualizar,
      };

      this.$store.dispatch("actualizarCliente", clienteActualizar);
    },
  },
  created() {
    let cliente = this.$store.getters.cliente;
    // Fechas created inicio
    if (cliente != null) {
      if (cliente.fechaNacimiento) {
        this.fechaInicial = new Date(cliente.fechaNacimiento)
          .toISOString()
          .substr(0, 10);
        this.form.fecha = this.fechaInicial;
      }
    }

    if (!this.fecha) {
      this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
    }
    // Fechas created fin
    //console.log(cliente)
    let credenciales = this.$store.getters.credencialesLogin;
    if (credenciales != null) {
      this.form.idTipoDocumento = credenciales.idTipoDocumento;
    }

    this.disabledDocumento = true;
    if (cliente && cliente.documento != null) {
      if (cliente.nombre2 == null || cliente.nombre2 == "") {
        this.form.nombreCompleto =
          cliente.nombre1 + " " + cliente.apellido1 + " " + cliente.apellido2;
      } else {
        this.form.nombreCompleto =
          cliente.nombre1 +
          " " +
          cliente.nombre2 +
          " " +
          cliente.apellido1 +
          " " +
          cliente.apellido2;
      }
      this.form.idTipoDocumento = cliente.idTipoDocumento;
      this.form.documento = cliente.documento;
      this.form.sexo = cliente.sexo;
      this.form.telefonoMovil = cliente.telefonoMovil;
      this.disabled = true;
      this.visibleActualizar = true;
      this.visibleRegistrar = false;
    } else {
      //this.form.documento = cliente.documento
      this.disabled = false;
      this.visibleActualizar = false;
      this.visibleRegistrar = true;
      if (cliente.documentoBusqueda != null) {
        this.form.documento = cliente.documentoBusqueda;
      }
    }
  },
  validations: {
    form: {
      // nombre1: {
      //   required,
      //   minLength: minLength(3),
      //   letrasEspacios
      // },
      // nombre2: {
      //   minLength: minLength(3),
      //   letrasEspacios
      // },
      // apellido1: {
      //   required,
      //   minLength: minLength(3),
      //   letrasEspacios
      // },
      // apellido2: {
      //   minLength: minLength(3),
      //   letrasEspacios
      // },
      idTipoDocumento: {
        minValue: minValue(1),
      },
      documento: {
        required,
        minLength: minLength(6),
      },
      sexo: {
        required,
      },
      telefonoMovil: {
        required,
        numeric,
        minLength: minLength(10),
        maxLength: maxLength(10),
      },
      nombreCompleto: {
        required,
        minLength: minLength(3),
        letrasEspacios,
        CantidadCadenaNombre,
      },
      fecha: {
        required,
      },
    },
  },
};
</script>